import { ArrowLeft, Clock3, Mic, MoreHorizontal } from "lucide-react";
import { Button } from "@akuna/ui";

interface MobileMedicalRecordHeaderProps {
  title: string;
  subtitle?: string | null;
  backLabel: string;
  contextLabel: string;
  transcriptionLabel: string;
  moreLabel: string;
  showContext: boolean;
  showTranscription: boolean;
  showOverflow: boolean;
  onBack: () => void;
  onOpenContext: () => void;
  onOpenTranscription: () => void;
  overflowMenu?: React.ReactNode;
}

export function MobileMedicalRecordHeader({
  title,
  subtitle,
  backLabel,
  contextLabel,
  transcriptionLabel,
  moreLabel,
  showContext,
  showTranscription,
  showOverflow,
  onBack,
  onOpenContext,
  onOpenTranscription,
  overflowMenu,
}: MobileMedicalRecordHeaderProps) {
  const iconButtonClass = "h-[38px] w-[38px] shrink-0 rounded-full border border-border/60 bg-card shadow-sm";

  return (
    <header className="overscroll-none shrink-0 border-b border-border/40 bg-background-app/95 px-4 py-3 backdrop-blur-md">
      <div className="flex items-center gap-2.5">
        <Button variant="ghost" size="icon" className={iconButtonClass} onClick={onBack} aria-label={backLabel}>
          <ArrowLeft className="h-[18px] w-[18px]" />
        </Button>
        <div className="min-w-0 flex-1">
          <h1 className="truncate font-heading text-[19px] font-extrabold leading-tight tracking-tight">{title}</h1>
          {subtitle ? <p className="mt-0.5 truncate text-xs text-muted-foreground">{subtitle}</p> : null}
        </div>
        {showContext ? (
          <Button variant="ghost" size="icon" className={iconButtonClass} onClick={onOpenContext} aria-label={contextLabel}>
            <Clock3 className="h-[18px] w-[18px]" />
          </Button>
        ) : null}
        {showTranscription ? (
          <Button
            variant="ghost"
            size="icon"
            className="h-[38px] w-[38px] shrink-0 rounded-full bg-primary/10 text-primary shadow-sm"
            onClick={onOpenTranscription}
            aria-label={transcriptionLabel}
          >
            <Mic className="h-[18px] w-[18px]" />
          </Button>
        ) : null}
        {showOverflow ? overflowMenu ?? (
          <Button variant="ghost" size="icon" className={iconButtonClass} aria-label={moreLabel}>
            <MoreHorizontal className="h-[18px] w-[18px]" />
          </Button>
        ) : null}
      </div>
    </header>
  );
}
